import request from '@/utils/request'

export function login(account, password,imgCode,imageCodeStr) {

  return request({
    url: '/appmanage/login/login',
    method: 'post',
    data: {
      account,
      password,
      imgCode,
      imageCodeStr
    },
  })
}
//获取验证码
export function getCode() {
  return request({
    url: '/appmanage/login/imageCode',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js